import React from 'react'
import Pg10 from '../../../myapp/services/add-money/Pg/Pg10.jsx'

function PG10Page() {
  return (
    <Pg10/>
  )
}

export default PG10Page